import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer } from "rxjs";
import { ApiService } from "../services/api-service";
import { ApiServiceDelegate } from "../services/api-service-delegate";
import { ApiCollection } from "../services/api-collection";
import { AppCommon } from "../app-common";
import { StandardResponseModel, StatusResponseModel } from "../models/basic.model";
import { TasksComponent } from "src/app/pages/tasks/tasks.component";
import { TaskComment, TaskCommentsResponseModel, TaskFilterModel, TaskModel, TaskResponseModel } from "../models/task.model";
import { NzMessageService } from "ng-zorro-antd/message";
import { TasksDrawerComponent } from "src/app/shared-components/tasks-drawer/tasks-drawer.component";
import { UserResponseModel } from "../models/user.model";
import { TasksDetailComponent } from "src/app/pages/tasks/tasks-detail/tasks-detail.component";
import { FeedbackIndResponseModel, FeedbackResponseModel } from "../models/feedback.model";
import { HttpHeaders, HttpResponse } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})

export class TasksViewModel {

    parentComponent: TasksComponent;
    parentComponentDrawer: TasksDrawerComponent;
    parentComponentDetails: TasksDetailComponent;
    feedbackModel = new BehaviorSubject<FeedbackIndResponseModel> (new FeedbackIndResponseModel())
    applications = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel);
    statuses = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel);

    tasksResponseModel = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel);
    userResponseModel = new BehaviorSubject<UserResponseModel>(new UserResponseModel);
    taskDetailModel = new BehaviorSubject<TaskModel>(new TaskModel);
    commentsResponseModel = new BehaviorSubject<TaskCommentsResponseModel>(new TaskCommentsResponseModel);
    feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());
 

    constructor(
        private apiService: ApiService,
        private message: NzMessageService,

        // private notification :NotificationService
    ) {

    }

    subscribeToTaskDrawer(
        observerFeedback: Observer<FeedbackIndResponseModel>,observerStatuses: Observer<StandardResponseModel>,
    ){
        this.feedbackModel.subscribe(observerFeedback);
        this.statuses.subscribe(observerStatuses);

    }

    subscribeToTaskDetails(
        observerTaskDetails: Observer<TaskModel>,
        observerApplications: Observer<StandardResponseModel>,
        observerStatuses: Observer<StandardResponseModel>,
        observerUserResponseModel: Observer<UserResponseModel>,
        observerCommentsResponseModel: Observer<TaskCommentsResponseModel>
    ){
        this.taskDetailModel.subscribe(observerTaskDetails);
        this.applications.subscribe(observerApplications);
        this.statuses.subscribe(observerStatuses);
        this.userResponseModel.subscribe(observerUserResponseModel);
        this.commentsResponseModel.subscribe(observerCommentsResponseModel)
    }


    subscribeToTasks(
      observerApplications: Observer<StandardResponseModel>,
      observerStatuses: Observer<StatusResponseModel>,
      observerTasks: Observer<TaskResponseModel>,
      observerUserResponseModel: Observer<UserResponseModel>,
    ){
      this.applications.subscribe(observerApplications);
      this.statuses.subscribe(observerStatuses);
      this.tasksResponseModel.subscribe(observerTasks);
      this.userResponseModel.subscribe(observerUserResponseModel);
    }


    getApplications(caller){
        let url = ApiCollection.APPLICATIONS + '?page=1&page_size=100'
        if(caller == 'tasks'){
            url += ' &check_permission=true'
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                 
                this.applications.next(e)
                if(caller == 'tasks'){
                    this.parentComponent.applicationsReceived();
                }
                if(caller == 'tasks-detail'){
                    this.parentComponentDetails.applicationsReceived();
                }

                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading applications", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    
    getFeedbacks(pageNo , filters ){
        var str = '?page='+pageNo + '&page_size=1000';
       
        str += this.getPayload(filters);
          let d: ApiServiceDelegate = {
              Data: {},
              Method: "GET",
              Action: ApiCollection.FEEDBACK + str,
              Success: (e: any) => {
                  this.feedbackResponseModel.next(e);
                  this.parentComponentDrawer.feedbackReceived();
                   
                  return e;
              },
              Error: (e: String) => {
                  this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                  return e;
              },
          };
          this.apiService.callService(d);
      }

      getFeedbackInd(id){
        var str = '/' + id;
          let d: ApiServiceDelegate = {
              Data: {},
              Method:     "GET" ,
              Action: ApiCollection.FEEDBACK + str,
              Success: (e: any) => {
                  this.feedbackModel.next(e);
                  this.parentComponentDrawer.feedbackReceived();
                  
                    
                  return e;
              },
              Error: (e: String) => {
                  this.message.error("Error while loading feeedbacks", {nzDuration: 1000});
                  return e;
              },
          };
          this.apiService.callService(d);
      }

      removeMedia(media_id){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.MEDIA + '/' + media_id,
            Success: (e: any) => {
             this.parentComponentDrawer.attachmentRemoved(media_id);
                 
                this.message.success("Media removed", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while removing media", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    downloadMedia(url, name){
        var completeUrl = url;
        let httpHeaders = new HttpHeaders();
        httpHeaders.append("Accept", "application/json");
        this.apiService.downloadFile(completeUrl, httpHeaders).subscribe((e: any) => {

         this.parentComponentDrawer.fileDownloaded(e.res.body, name);
            
        },
        (error: any) => {
            this.message.error('Error while downloading');
            return error;
          }

        );
    }

    uploadMedia(file, currentUser, fileName,caller:string=null){
        var formData = new FormData();
        var httpHeaders = new HttpHeaders();
        var uploadContentType = { type: 'multipart/form-data' }
        formData.set('file', new Blob([file], uploadContentType), file.name);
        formData.set('created_by', currentUser);
        formData.set('name', fileName);
        httpHeaders.append('Accept', 'application/x-www-form-urlencoded');
        this.apiService.uploadFile(String(ApiCollection.MEDIA), formData,  httpHeaders).subscribe((e: any) => {
            if(caller=="task-detail"){
                this.parentComponentDetails.fileUploaded(e.res)
            }else{

                this.parentComponentDrawer.fileUploaded(e.res);
            }
            
            this.message.success('File uploaded');
          },
          (error: any) => {
            
            
         this.parentComponentDrawer.fileUploadedError();
            
            this.message.error(error);
          }
          );




    }

    getAppDashboard(id){
        var str = ''
        if (id!=undefined){
            str+='?application='+id
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK_DASHBOARD + str,
            Success: (e: any) => {
                
                this.parentComponent.appDashboardReceived(e);
    
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading statues", {nzDuration: 1000})
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getStatuses(id,caller){
        var str = ''
        if (id!=undefined){
            str+='?application='+id
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK_STATUS + str,
            Success: (e: any) => {
                this.statuses.next(e)
                if(caller == 'Task'){
                    this.parentComponent.statusesReceived();
                }
                if(caller == 'tasks-detail'){
                    this.parentComponentDetails.statusesReceived();
                }
                if (caller=='Task-Drawer'){
                    this.parentComponentDrawer.statusesReceived()
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading statues", {nzDuration: 1000})
                if (caller=='Task-Drawer'){
                    this.parentComponentDrawer.statusesLoadFailed()
                }
                return e;
            },
        };
        this.apiService.callService(d);
    }


    createTask(taskModel: TaskModel){
        let d: ApiServiceDelegate = {
            Data: taskModel,
            Method: "POST",
            Action: ApiCollection.TASK,
            Success: (e: any) => {
                this.parentComponentDrawer.taskUpdated();
                this.message.success("Task Created", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading statues", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getPayload(filters: TaskFilterModel){
        var str = '';
        if(filters.name?.length > 0){
            str += "&name=" + encodeURIComponent(filters.name);
        }
        if(filters.application){
            str += "&application=" + filters.application; 
          
        }else if(filters.application?.length >1 ){
            str += "&application=" + filters.application.join(',');
        }
        if (filters.assigned_to) {
             str += "&assigned_to=" + filters.assigned_to;
        }else if(filters.assigned_to?.length > 1){
            str += "&assigned_to=" + filters.assigned_to.join(',');
        } 
        if(filters.status){
            str += "&status=" + filters.status;
        }else if(filters.status?.length > 1 ){
            
            str += "&status=" + filters.status.join(',');
        }
        if(filters.task_type?.length > 0){
            str += "&task_type=" + filters.task_type.join(',');
        }
        if(filters.date_order){
            str += "&date_order=" + filters.date_order
        }
        if(filters.descend){
            str += "&desc=" + filters.descend
        }
        if(filters.ascend){
            str += "&asc=" + filters.ascend
        }
        if(filters.assigned_to_order){
            str += "&assigned_to_order=" + filters.assigned_to_order
        }
        if(filters.priority_order){
            str += "&priority_order=" + filters.priority_order
        }
        if(filters.title){
            str += "&title=" + filters.title
        }
        if(filters.filter_due_date__lte){
            str += "&filter_due_date__lte=" + filters.filter_due_date__lte
        }
        if(filters.filter_due_date__gte){
            str += "&filter_due_date__gte=" + filters.filter_due_date__gte
        }
        return str
    }

    getTasks(filters: TaskFilterModel,pageNo, page_size){
        var str = '?page='+pageNo + '&page_size=' + page_size;
        str += this.getPayload(filters);
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK + str,
            Success: (e: any) => {
                this.tasksResponseModel.next(e);
                this.parentComponent.tasksReceived();
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    exportTasks(filters: TaskFilterModel){
 
            var url = "";
            var fileName = "filteredTasklist.csv";
            url= ApiCollection.TASK_EXPORT +'?page=1'+ this.getPayload(filters),
            // HeaderComponent.myApp.showSpinner()
            this.apiService.download(url).subscribe((e: HttpResponse<Blob>) => {
                const blob: any = new Blob([e.body], { type: 'text/csv' });
                let link = document.createElement("a");
                if (link.download !== undefined) {
                  let url = URL.createObjectURL(blob);
                  link.setAttribute("href", url);
                  link.setAttribute("download", fileName);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
           
                }
              },
              (error: any) => {
                this.message.error('Error while downloading');
              }
            );
        
    }

    getTaskById(id){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK + '/' + String(id),
            Success: (e: any) => {
                this.taskDetailModel.next(e);
                this.parentComponentDetails.taskReceived();
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                this.parentComponentDetails.taskNotReceived();
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskWorkTime(taskId, createdBy, pageNo, pageSize, successCallback, errorCallback){
        var str = '?';
        if(pageNo && pageSize){
            str += 'page=' + pageNo + '&page_size=' + pageSize + '&';
        }
        str += 'task=' + encodeURIComponent(String(taskId));
        if(createdBy){
            str += '&created_by=' + createdBy;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.WORK_TIME + str,
            Success: (e: any) => {
                successCallback(e);
                return e;
            },
            Error: (e: any) => {
                errorCallback(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getActiveWorkTimes(createdBy, pageNo, pageSize, successCallback, errorCallback){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.WORK_TIME + '?page=' + pageNo + '&page_size=' + pageSize + '&created_by=' + createdBy + '&is_active=true',
            Success: (e: any) => {
                successCallback(e);
                return e;
            },
            Error: (e: any) => {
                errorCallback(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getActiveTaskWorkTime(taskId, createdBy, successCallback, errorCallback){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.WORK_TIME + '?page=1&page_size=1&task=' + taskId + '&created_by=' + createdBy + '&is_active=true',
            Success: (e: any) => {
                successCallback(e);
                return e;
            },
            Error: (e: any) => {
                errorCallback(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    workTimeAction(taskId, action: 'start' | 'stop' | 'manual', createdBy, successCallback, errorCallback, manualTimes: any = {}){
        let data = {
            task: taskId,
            action: action,
            created_by: createdBy
        };
        if(action == 'manual'){
            data['start_time'] = manualTimes.start_time;
            data['end_time'] = manualTimes.end_time;
        }
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.WORK_TIME_ACTION,
            Success: (e: any) => {
                successCallback(e);
                return e;
            },
            Error: (e: any) => {
                errorCallback(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateManualWorkTime(workTimeId, payload, successCallback, errorCallback){
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.WORK_TIME + '/' + String(workTimeId),
            Success: (e: any) => {
                successCallback(e);
                return e;
            },
            Error: (e: any) => {
                errorCallback(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteComment(commentId, taskId){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.TASK_COMMENT + '/' + String(commentId),
            Success: (e: any) => {
                // this.commentsResponseModel.next(e);
                this.getTaskComments(taskId);
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while deleting comment", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskComments(taskId){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.TASK_COMMENT + '?page=1&page_size=1000'+ '&task=' + String(taskId),
            Success: (e: any) => {
                this.commentsResponseModel.next(e);
                this.parentComponentDetails.commentsReceived()
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading task comments", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateTask(id, data, caller){
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.TASK + '/' + String(id),
            Success: (e: any) => {
                // this.taskDetailModel.next(e);
                if(caller == 'task-drawer'){
                    this.parentComponentDrawer.taskUpdated();
                }
                if(caller == 'tasks-detail'){
                    this.parentComponentDetails.taskUpdated();
                }
                this.message.success("Task updated", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                if(caller == 'task-drawer'){
                    this.parentComponentDrawer.errorOnTaskUpdate();
                }
                if(caller == 'tasks-detail'){
                    this.parentComponentDetails.errorOnTaskUpdate();
                }
                this.message.error("Error while updating task", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteTask(id){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.TASK + '/' + String(id),
            Success: (e: any) => {
                this.parentComponentDetails.taskDeleted();
                this.message.success("Task deleted", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while deleting task", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getUsers(caller){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.USER + "?page=1&page_size=1000" ,
            Success: (e: any) => {
                this.userResponseModel.next(e);
                if(caller == 'tasks'){
                    this.parentComponent.usersReceived();
                }
                if(caller == 'tasks-detail'){
                    this.parentComponentDetails.usersReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskHistry(id){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.HISTROY.replace('{id}',id) + "?page=1&page_size=1000" ,
            Success: (e: any) => {
                 
                this.parentComponentDetails.taskHistroyReceived(e);
                
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks histry", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateTaskComment(taskComment: TaskComment){
        let url = ApiCollection.TASK_COMMENT + '/' + String(taskComment.id)
         
        let d: ApiServiceDelegate = {
            Data: taskComment,
            Method: "PATCH",
            Action: url ,
            Success: (e: any) => {
                // this.userResponseModel.next(e);
                this.parentComponentDetails.commentUpdated();
                this.message.success("You commented on this task", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createTaskComment(taskComment: TaskComment){
        let url = ApiCollection.TASK_COMMENT
        
        
        let d: ApiServiceDelegate = {
            Data: taskComment,
            Method: "POST",
            Action:url,
            Success: (e: any) => {
                // this.userResponseModel.next(e);
                this.parentComponentDetails.commentUpdated();
                this.message.success("You commented on this task", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                this.message.error("Error while loading tasks", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


}
